export const borderRadius = {
  default: 4,
};
